export default __webpack_public_path__ + "static/media/serviceRequest.d34dbf8c.svg";